import { createFileRoute, redirect } from '@tanstack/react-router'

// The page was called Card phones: old links land on Card payments.
export const Route = createFileRoute('/_authenticated/events/$eventId/card-phones')({
  beforeLoad: ({ params }) => {
    throw redirect({ to: '/events/$eventId/card-payments', params })
  },
})
